//global styles include all custom css rules intended to be used throughout the UI for this project
//all global styles are imported into the 'instarent' plugin

/**
 * @author -- Peter Collins cpnzereogu@gmail
 */

import Animations from "./anim.css"
import Fonts from "./fonts.css"
import Styles from "./styles.css"
import Themes from "./theme.css"

export default {
    Animations, Fonts, Styles, Themes
}
